module.exports = __webpack_public_path__ + "static/image-somos-1-d2f7cedac5b9a2c072480b3884ae817d.jpg";